import { useState } from "react";
import StaffEntry from "./StaffEntry";
import classes from "./StaffComponent.module.css";
import { IoAddCircle, IoCheckmarkCircleSharp } from "react-icons/io5";
import ToggleSwitch from "./ToggleSwitch";
import domain from "../domain";
import {
  deleteStaffEntry,
  getStaffInfoById,
  setStaffData,
} from "../util/multipleBranch/staffRegisterUtil";

//IMPORTANT we dont fetch staff data from DB because in admin Dashboard we are already fetching
// questions from DB and Questions document contains staff register and also
// staffRegister is set in local storage in Admin dashBoard.

//Parent component = StaffRegister
export default function StaffComponent() {
  console.log("rendering staff Component");
  let selfId = localStorage.getItem("id");
  let data = getStaffInfoById(selfId);
  console.log(data);

  if (data == null) data = [];
  const [refresh, setRefresh] = useState(false);

  // newEntry state tells us if edit button
  const [newEntry, setNewEntry] = useState(false);

  async function deleteHandler(id) {
    console.log(id);
    let restaurantId = localStorage.getItem("restaurantId");
    let branchId = localStorage.getItem("id");
   
    let res = await deleteFromDbHandler(restaurantId, id);
    console.log("res", res);
    deleteStaffEntry(branchId, id);
    setStaffData(branchId, res.result);
   
    setRefresh((prev) => !prev);
  }

  function addStaff(name) {}

  function addButtonHandler() {
    console.log("i am clicked");
    setNewEntry(true);
    let inputDiv = document.getElementById("newEntry");
    inputDiv.style.display = "block";
    console.log(inputDiv);
    let input = document.getElementById("nameInput");
    console.log(input);
    input.focus();
  }

  async function saveButtonHandler(e) {
    setNewEntry(false);
    let inputDiv = document.getElementById("newEntry");
    inputDiv.style.display = "none";

    let name1 = document.getElementById("nameInput").value.trim();
    // capitalizing first letter of name.
    let name = `${name1.charAt(0).toUpperCase()}${name1.slice(1)}`;
    if (name != "") {
      document.getElementById("nameInput").value = "";

      // we need uniqu id so we use date to get milli second passed from epoch time.
      const d = new Date();
      let id = d.getTime();
      // id ex.  1730718175343

      let obj = {
        id: id.toString(),
        name,
        rating: [],
      };
      //now we append this object to array stored in local storage
      
      data.push(obj);
      console.log("data locally")
      console.log(data);
      // saving in local storage
     
      // also update the localstorage Questions.staff property.
      /** because incase staffRegister becomes null and questions is presenet in
       * local storage then staffRegister is copied from questions.staff.
       */
      // let questionStorage = JSON.parse(localStorage.getItem("questions"));
      // questionStorage.staff = data;
      // localStorage.setItem("questions", JSON.stringify(questionStorage));

     let res = await saveToDbHandler(id, name);
     console.log("res", res.result);
     let branchId = localStorage.getItem("id");
     setStaffData(branchId, res.result);
     console.log("data locally after saving to db")
     setRefresh((prev) => !prev);

    }
  }

  // below function used to send staffRegister array to DB.
  async function saveToDbHandler(id, name) {
    console.log("test");

   let branchId = localStorage.getItem("id");
   
    // body should have restaurantId , id and name of staff.
    let restaurantId = localStorage.getItem("restaurantId");
    const body = { restaurantId, branchId, id, name };
    try {
      const data1 = await fetch(`${domain}/api/staff`, {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },

        body: JSON.stringify(body),
      });

      const data = await data1.json();
       console.log(data);
      if (data1.status == "200") alert("DATA saved to data base successfully");
      else if (data1.status == "400")
        alert(
          "Failure occured while saving Data to Data base, retry After Some Time."
        );
      return data;
    } catch (err) {
      return err;
    }
  }

  async function deleteFromDbHandler(restaurantId, id) {
    console.log("running delete from db handler");
   
   
    const body = { restaurantId, id };
    try {
      const data1 = await fetch(`${domain}/api/staff`, {
        method: "delete",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      });
      const data = await data1.json();
      console.log(data);
      return data;
    } catch (err) {
      return err;
    }
  }

  function saveEditHandler(id, name) {
    console.log("running save edit handler");
    //updating staffRegister loal storage.
    let selfBID = localStorage.getItem("id");
    const data = getStaffInfoById(selfBID);
    console.log(data);
    const d = data.map((item) => {
      if (item.id == id) {
        item.name = name;
      }
      return item;
    });
    console.log(d);
    setStaffData(selfBID, d);
    saveToDbHandler();
    setRefresh((prev) => !prev);
  }
  return (
    <>
      {data &&
        data.map((item, index) => {
          return (
            <StaffEntry
              key={index}
              data={item}
              index={index}
              deleteHandler={deleteHandler}
              saveEditHandler={saveEditHandler}
            />
          );
        })}

      <div className={classes.newEntryContainer}>
        <div
          id="newEntry"
          className={
            newEntry ? `${classes.newEntry} ` : `${classes.hiddenNewEntry}`
          }
        >
          <input type="text" id="nameInput" autoFocus={true} />
          <div
            className={classes.iconBox}
            onClick={(e) => {
              saveButtonHandler(e);
            }}
          >
            <div className={classes.saveIcon}>
              <IoCheckmarkCircleSharp />
            </div>
          </div>
        </div>

        <div>
          <div
            className={
              newEntry ? `${classes.hiddenNewEntry}  ` : `${classes.NewEntry}  `
            }
            onClick={addButtonHandler}
          >
            <div className={`${classes.iconBox}`}>
              {" "}
              <IoAddCircle />{" "}
            </div>
            <span style={{ color: "grey", fontSize: "0.8rem" }}>
              Add New Staff
            </span>
          </div>
        </div>
      </div>
      {/* 
      <div className={classes.saveDbContainer}>
        <div className={classes.saveButton}>
          <button type="button" onClick={saveToDbHandler}>
            Save
          </button>
        </div>
      </div> */}
    </>
  );
}
